import { ReactElement } from 'react';
import { UsersTable } from './UsersTable';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { setStatusFilter, useStatusFilter } from '../store';

export const FilterOptions = (): ReactElement => {
  const form = useForm();
  const status = useStatusFilter();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const data = event.target.name;
    if (status.includes(data))
      setStatusFilter(status.filter((stat) => stat !== data));
    else setStatusFilter([...status, data]);
  };

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Typography noWrap fontSize={'12px'}>
        Show only:
      </Typography>
      <FormControl component="fieldset" variant="standard">
        <Stack direction="row" gap={2} alignItems="center">
          {/* <FormLabel sx={{ color: 'black' }}> */}
          {/* </FormLabel> */}
          <FormGroup>
            <Stack direction="row" alignItems="center">
              <FormControlLabel
                control={<Checkbox onChange={handleChange} name="active" />}
                label="Active"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  },
                }}
              />
              <FormControlLabel
                control={<Checkbox onChange={handleChange} name="inactive" />}
                label="Inactive"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  },
                }}
              />
              <FormControlLabel
                control={<Checkbox onChange={handleChange} name="pending" />}
                label="Pending"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  },
                }}
              />
              <FormControlLabel
                control={<Checkbox onChange={handleChange} name="new-user" />}
                label="New User"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  },
                }}
              />
            </Stack>
          </FormGroup>
        </Stack>
      </FormControl>
    </Stack>
  );
};
